<template>
  <div class="service-editor">
    <div class="row">
      <div class="col icon-container">
        <label class="label">ไอคอน</label>
        <img class="thumbnail" :src="thumbnailUrl" />
        <sc-button
          class="thumbnail-button"
          v-if="!disabled"
          @click="handleClickChooseIconButton"
          >เลือกไอคอน</sc-button
        >
      </div>
      <div class="col">
        <label class="label">ชื่อ</label>
        <el-input
          class="input"
          :disabled="disabled"
          v-model="value.name"
        ></el-input>
        <label class="label">รายละเอียด (อย่างย่อ)</label>
        <el-input
          class="input"
          :disabled="disabled"
          v-model="value.shortDescription"
        ></el-input>
        <el-checkbox class="input" v-model="hasExternalLink"
          >มี external-link</el-checkbox
        >
        <div v-if="hasExternalLink" class="externalLink">
          <label class="label">หัวข้อ</label>
          <el-input
            class="input"
            :disabled="disabled"
            v-model="value.externalLink.title"
            >ชื่อหัวข้อ</el-input
          >
          <label class="label">ประเภท</label>
          <el-select
            class="input"
            v-model="value.externalLink.type"
            placeholder="Select"
          >
            <el-option
              v-for="item in externalLinkTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <label class="label">URL</label>
          <el-input
            class="input"
            :disabled="disabled"
            v-model="value.externalLink.url"
            >URL</el-input
          >
        </div>
        <div class="row">
          <div class="col-3">
            <label class="label">ผู้ให้บริการ</label>
            <provider-selector
              class="input"
              v-model="value.provider"
              :disabled="isCanNotEditService || disabled"
              :isShowProviderVat="true"
            ></provider-selector>
          </div>
          <div class="col-3">
            <label class="label">ประเภทของสินค้าและบริการ (SAP)</label>
            <el-select
              v-model="value.sapServiceType"
              style="width: 100%"
              :disabled="isCanNotEditService"
            >
            <el-option
              v-for="t in sapServiceTypeDropdown"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
            </el-select>
          </div>
        </div>
        <div class="input">
          <input
            type="radio"
            name="type"
            value="false"
            v-model="hasQuota"
            :disabled="isCanNotEditService"
            @click="handleSelectOnetime(true)"
          />
          &nbsp; สินค้า &nbsp;&nbsp;
          <input
            type="radio"
            name="type"
            value="true"
            v-model="hasQuota"
            :disabled="isCanNotEditService"
            @click="handleSelectOnetime(false)"
          />
          &nbsp; บริการ
        </div>
        <div v-if="hasQuota" class="input">
          <label class="label">ประเภทของบริการ</label>
          <input
            type="radio"
            name="serviceType"
            value="SERVICE"
            v-model="value.serviceType"
            :disabled="isCanNotEditService"
          />
          &nbsp; บริการ &nbsp;&nbsp;
          <input
            type="radio"
            name="serviceType"
            value="PRODUCT"
            v-model="value.serviceType"
            :disabled="isCanNotEditService"
          />
          &nbsp; สินค้าที่ให้ลูกค้านัดบริการ
        </div>
        <div
          class="input"
          v-if="isShowMaterialCode && hasQuota"
        >
          <label class="label">รับรู้รายได้บน SAP</label>
            <el-select
              v-model="value.sapServiceRecognizeRevenue"
              class="revenue-dropdown"
              :disabled="isCanNotEditService"
            >
            <el-option
              v-for="t in sapServiceRecognizeRevenueDropdown"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
            </el-select>
        </div>
        <el-checkbox
          v-model="hasOptions"
          :disabled="isCanNotEditService"
          >มี options</el-checkbox
        >
        <p class="service-vat">{{ vatRegisteredByService }}</p>
        <template v-if="!isSelectOnetimeType || hasQuota">
          <div>
            <label class="label">จำนวนครั้งที่จัดส่ง (สินค้า/บริการ)</label>
            <el-input
              class="input quota"
              :disabled="disabled"
              :value="quota"
              @input="handleChangeInput('quota', $event)"
              type="number"
              :min="0"
              :readonly="isReadOnly"
            ></el-input>
          </div>
          <!-- TODO: show service appointment date constraint when ready on production -->
          <!-- <service-appointment-date-constraint-editor
            v-model="value.appointDateConstraints"
            v-show="hasQuota"
          >
          </service-appointment-date-constraint-editor> -->
          <service-appointment-duration
            v-if="!hasOptions"
            v-model="value"
            @removeDuration="handleRemoveDuration"
            @addDuration="handleAddDuration"
            @totalCost="handleTotalCost"
          ></service-appointment-duration>
        </template>
        <div v-if="!hasOptions">
          <label class="label">ต้นทุนรวม</label>
          <el-input
            class="input cost"
            :disabled="disabled"
            :value="cost"
            :readonly="hasQuota"
            @input="handleChangeInput('cost', $event)"
            type="number"
          ></el-input>
        </div>
        <div v-if="!hasOptions && isShowMaterialCode">
          <div class="row">
            <div class="col-6">
              <label class="label">Material Code</label>
              <material-selector
                v-model="value.materialCode"
                @unitName="handleUnitName"
              ></material-selector>
            </div>
            <div class="col-3">
              <label class="label">จำนวน{{ value.unitName }}</label>
              <material-quantity-selector
                v-model="value.materialQuantity"
              ></material-quantity-selector>
            </div>
          </div>
        </div>
        <div v-if="hasQuota">
          <label class="label">จำนวนวันนัดล่วงหน้า</label>
          <el-input
            class="input minimumAdvanceDuration"
            :disabled="isCanNotEditService"
            :value="minimumAdvanceDuration"
            @input="handleChangeInput('minimumAdvanceDuration', $event)"
            min="1"
            type="number"
          ></el-input>
        </div>

        <!-- TODO: remove ENV check when ready to production -->
        <template v-if="hasOptions">
          <div>
            <service-option-editor
              v-model="serviceOptions"
              @setEmptyServiceOptionCosts="handleEmptyOptionCost"
              @isCheckCombineOption="handleCheckCombineOption"
            ></service-option-editor>
          </div>
          <div>
            <div v-if="hasOptionSwitch">
              <sc-button
                variant="primary"
                @click="handleClickGenerateCombineOption"
                >สรุป ราคาทุน</sc-button
              >
            </div>
            <div v-else>
              <sc-button variant="primary" @click="handleClickEditOption"
                >แก้ไข option</sc-button
              >
            </div>
          </div>
          <div>
            <template v-if="hasAppointCosts">
              <service-list-option
                v-model="serviceOptionCosts"
              ></service-list-option>
            </template>
          </div>
        </template>
        <label class="label">รายละเอียด</label>
        <el-input
          class="input"
          :disabled="disabled"
          v-model="value.description"
          type="textarea"
          rows="7"
        ></el-input>
        <label class="label">เงื่อนไขการใช้บริการ</label>
        <el-input
          class="input"
          :disabled="disabled"
          v-model="value.termsAndConditions"
          type="textarea"
          rows="7"
        ></el-input>
        <label class="label" v-if="packagesByServiceList"
          >แพ็คเกจที่ร่วมบริการ</label
        >
        <div>
          <package-list-item
            v-for="item in packagesByServiceList"
            :key="item.key"
            v-bind="item"
          >
          </package-list-item>
        </div>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseIconDialog"
      @cancel="handleCancelChooseIconDialog"
      @confirm="handleConfirmChooseIconDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import { Input, Select, Option, Checkbox, Pagination } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import ProviderSelector from "@/lib/components/ProviderSelector";
import { isNil } from "ramda";
import ServiceOptionEditor from "./ServiceOptionEditor";
import ServiceAppointmentDuration from "./ServiceAppointmentDuration";
import ServiceAppointmentDateConstraintEditor from "./ServiceAppointmentDateConstraintEditor";
import PackageListItem from "../../packages/components/PackageListItem";
import ServiceListOption from "./ServiceListOption.vue";
import { uuid } from "vue-uuid";
import materialSelector from "@/lib/components/materialSelector";
import materialQuantitySelector from "@/lib/components/materialQuantitySelector";
import { serviceType } from "@/lib/mapper";

export default {
  props: ["value", "iconUrl", "disabled", "providers"],
  components: {
    ScButton,
    ImagePickerModal,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
    ProviderSelector,
    ServiceOptionEditor,
    ServiceAppointmentDuration,
    ServiceAppointmentDateConstraintEditor,
    PackageListItem,
    "el-pagination": Pagination,
    ServiceListOption,
    "material-selector": materialSelector,
    "material-quantity-selector": materialQuantitySelector
  },
  data() {
    const sapServiceTypeDropdown = [
      { value: "PREPAID", label: "Prepaid" },
      { value: "CUSTOMIZED", label: "Customized" },
      { value: "NORMAL", label: "Normal" },
    ]

    const sapServiceRecognizeRevenueDropdown = [
      { value: "APPOINTMENT_REVENUE", label: "รับรู้รายได้ทุกครั้งที่นัด" },
      { value: "ONETIME_REVENUE", label: "รับรู้รายได้ครั้งเดียว" },
    ]

    const permission = JSON.parse(localStorage.getItem("adminRolePermission")) || null;

    return {
      isShowModal: false,
      externalLinkTypeOptions: [
        {
          value: "PDF",
          label: "PDF"
        }
      ],
      hasExternalLink: false,
      isEditTotalCost: false,
      isSelectOptionType: false,
      isSelectOnetimeType: true,
      sapServiceTypeDropdown,
      unitNameSelect: null,
      sapServiceRecognizeRevenueDropdown,
      permission
    };
  },
  computed: {
    name() {
      return this.value.name;
    },
    shortDescription() {
      return this.value.shortDescription;
    },
    quota() {
      return this.value.quota;
    },
    cost() {
      return this.value.cost;
    },
    minimumAdvanceDuration() {
      return this.value.minimumAdvanceDuration;
    },
    description() {
      return this.value.description;
    },
    termsAndConditions() {
      return this.value.termsAndConditions;
    },
    isCanNotEditService() {
      return this.value.isCanNotEditService;
    },
    serviceOptions: {
      get() {
        return this.value;
      },
      set(serviceOptions) {
        this.$emit("input", { ...this.value, serviceOptions });
      },
    },
    hasAppointCosts() {
      return this.hasAppointmentCosts();
    },
    serviceOptionCosts: {
      get() {
        return this.value;
      },
      set(serviceOptionCosts) {
        this.$emit("input", { ...this.value, serviceOptionCosts });
      },
    },
    thumbnailUrl() {
      if (!this.chooseIconDialog.thumbnailUrl) {
        return "https://placehold.co/300";
      }

      return this.chooseIconDialog.thumbnailUrl;
    },
    chooseIconDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: !this.disabled,
        title: "เลือกรูปไอคอนบริการ",
        width: 200,
        height: 200,
        recommendWidth: 200,
        recommendHeight: 200,
        thumbnailFile: this.value.iconFile,
        thumbnailUrl: this.iconUrl
      };
    },
    hasOptions: {
      get() {
        return !isNil(this.value.serviceOptions);
      },
      set(hasOptions) {
        const serviceOptions = hasOptions
          ? [
              {
                id: uuid.v4(),
                title: "",
                extra_option: false,
                is_show_delete_option: "hasOption",
                variants: [
                  {
                    variant_id: uuid.v4(),
                    title: "",
                    is_out_of_stock: false,
                    is_not_sale: false,
                    is_show_delete_option: "hasOption",
                    material_code: null,
                    material_quantity: null
                  },
                  {
                    variant_id: uuid.v4(),
                    title: "",
                    is_out_of_stock: false,
                    is_not_sale: false,
                    is_show_delete_option: "hasOption",
                    material_code: null,
                    material_quantity: null
                  }
                ]
              }
            ]
          : null;

        this.$emit("input", {
          ...this.value,
          serviceOptions,
          serviceOptionCosts: null,
          hasOptionSwitch: true,
          appoint_duration_slots: null
        });
      },
    },
    hasQuota() {
      return this.quota > 0;
    },
    isReadOnly() {
      return this.value.appointCostReadOnly;
    },
    packagesByServiceList() {
      return this.value.packagesByServiceList;
    },
    isTotalCost() {
      return this.isEditTotalCost;
    },
    isOnetimeType() {
      return this.isSelectOnetimeType;
    },
    isOptionType() {
      return this.isSelectOptionType;
    },
    hasOptionSwitch() {
      return this.value.hasOptionSwitch;
    },
    isShowMaterialCode() {
      return this.value.sapServiceType === 'NORMAL';
    },
    vatRegisteredByService() {
      if (
        this.value.isVatRegistered !== undefined | null
        && typeof this.value.isVatRegistered == "boolean"
      ) {
        return this.value.isVatRegistered
          ? "บริการนี้ต้นทุนรวม Vat"
          : "บริการนี้ต้นทุนไม่รวม Vat";
      } else {
        if (!this.value.provider) {
          return "";
        }

        return this.value.provider.isVatRegistered
          ? "บริการนี้ต้นทุนรวม Vat"
          : "บริการนี้ต้นทุนไม่รวม Vat";
      }
    }
  },
  watch: {
    hasExternalLink() {
      this.handleHasExternalLinkChange();
    },
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.hasExternalLink = !!this.value.externalLink;
    },
    async handleChangeInput(key, value) {
      const isNumber = key === "quota" || "cost" || "minimumAdvanceDuration";

      await this.$emit("input", {
        ...this.value,
        [key]: isNumber ? +value : value,
      });

      if (key === "quota") {
        this.isEditTotalCost = value > 0 ? true : false;
        this.createCombineOptionDetail();

        this.$emit("input", {
        ...this.value,
        serviceType: this.isEditTotalCost
          ? serviceType.SERVICE
          : serviceType.PRODUCT
      });
      }
    },
    handleClickChooseIconButton() {
      this.showChooseIconDialog();
    },
    handleCancelChooseIconDialog() {
      this.hideChooseIconDialog();
    },
    handleConfirmChooseIconDialog(file) {
      this.$emit("input", { ...this.value, iconFile: file });
      this.hideChooseIconDialog();
    },
    showChooseIconDialog() {
      this.isShowModal = true;
    },
    hideChooseIconDialog() {
      this.isShowModal = false;
    },
    handleHasExternalLinkChange() {
      if (!this.hasExternalLink) {
        this.value.externalLink = null;
        return;
      }

      if (
        this.value.externalLink &&
        this.value.externalLink.title &&
        this.value.externalLink.url
      ) {
        return;
      }

      this.value.externalLink = { title: "", type: "PDF", url: "" };
    },
    handleRemoveDuration(dataForRemove) {
      this.$emit("removeDuration", dataForRemove);
    },
    handleAddDuration(slotNumber) {
      this.$emit("addDuration", slotNumber);
    },
    handleTotalCost(appointCost) {
      this.$emit("input", { ...this.value, cost: appointCost });
    },
    handleSelectOnetime(isOnetime) {
      const quota = isOnetime ? 0 : 1;

      const service = quota > 0
        ? serviceType.SERVICE
        : serviceType.PRODUCT

      this.$emit("input", { ...this.value, quota, serviceType: service });

      this.isSelectOnetimeType = isOnetime;
    },
    hasAppointmentCosts() {
      const hasAppointmentCosts = this.value.serviceOptionCosts
        ? true
        : false;

      return hasAppointmentCosts;
    },
    async handleClickGenerateCombineOption() {
      this.$emit("isCheckCombineOption", false);

      const hasEmptyOptionTitle = this.value.serviceOptions.some(
        (option) => !option.title ? true : false
      );

      const hasEmptyOptionVariant = this.value.serviceOptions.some((option) => {
        return option.variants.some((variant) =>
          !variant.title ? true : false
        );
      });

      if (hasEmptyOptionTitle === true) {
        alert("กรุณากรอก Title ให้ครบถ้วน");
        return;
      }

      if (hasEmptyOptionVariant === true) {
        alert("กรุณากรอก Variant ให้ครบถ้วน");
        return;
      }

      await this.createCombineOptionDetail();
    },
    async createCombineOptionDetail() {
      const quota = this.value.quota;
      const serviceOptions = this.value.serviceOptions;
      let serviceOptionCosts;

      const serviceMainOption = serviceOptions
        ? serviceOptions.find((option) => option.extra_option === false)
        : null;

      const serviceExtraOption = serviceOptions
        ? serviceOptions.find((option) => option.extra_option === true)
        : null;

      if (serviceMainOption && serviceMainOption.variants) {
        serviceOptionCosts = serviceMainOption.variants.map(
          (variant, variantIndex) => {
            const optionId = this.getOldOptionIdOrGenerate(variantIndex);
            let appointmentAmount = null;
            let isProduct = null;

            if (quota > 0) {
              appointmentAmount = new Array(quota).fill(0);
              isProduct = false;
            } else {
              appointmentAmount = new Array(1).fill(0);
              isProduct = true;
            }

            const appointments = appointmentAmount.map((_, index) => {
              return { no: index + 1, cost: null };
            });

            this.option = [
              {
                title: variant.title,
                is_not_sale: variant.is_not_sale,
                is_out_of_stock: variant.is_out_of_stock,
                material_code: variant.material_code,
                appointments,
                material_quantity: variant.material_quantity
              },
            ];

            if (serviceExtraOption) {
              serviceExtraOption.variants.map((variant) => {
                this.option.push({
                  title: variant.title,
                  is_not_sale: variant.is_not_sale,
                  is_out_of_stock: variant.is_out_of_stock,
                  material_code: variant.material_code,
                  appointments,
                  material_quantity: variant.material_quantity,
                });
              });
            }

            const combinationCosts = this.option.map((appointmentCost, appointmentCostIndex) => {
              const id = this.getOldCombineOptionIdOrGenerate(variantIndex, appointmentCostIndex);

              const appointmentCosts = appointmentCost.appointments.map((appoint) => {
                  const appointNo = appoint.no;
                  const cost = this.getOldCombineAppointmentValue(
                    variantIndex,
                    appointmentCostIndex,
                    appointNo,
                    "cost"
                  );

                  return {
                    appoint_no: appointNo,
                    cost
                  };
              });

              return {
                id,
                is_not_sale: appointmentCost.is_not_sale,
                is_out_of_stock: appointmentCost.is_out_of_stock,
                material_code: appointmentCost.material_code,
                title: appointmentCost.title,
                appointment_costs: appointmentCosts,
                material_quantity: appointmentCost.material_quantity
              };
            });

          return {
            id: optionId,
            title: variant.title,
            is_product: isProduct,
            combination_costs: combinationCosts
          };
        });
      }
      return this.$emit("input", {
        ...this.value,
        serviceOptionCosts,
        hasOptionSwitch: false,
      });
    },
    handleClickEditOption() {
      this.$emit("input", { ...this.value, hasOptionSwitch: true });
    },
    getOldCombineOptionIdOrGenerate(variantIndex,combineOptionIndex) {
      let combineOptionId = uuid.v4();

      if (this.value.serviceOptionCosts) {
        this.value.serviceOptionCosts.map((serviceOptionCost, serviceOptionCostIndex) => {
          if (serviceOptionCostIndex === variantIndex) {
            serviceOptionCost.combination_costs.map((combinationCost, combinationCostIndex) => {
              if (combinationCostIndex === combineOptionIndex) {
                combineOptionId = combinationCost.id;
              }
            })
          }
        });
      }

      return combineOptionId
    },
    getOldCombineAppointmentValue(
      variantIndex,
      combineOptionIndex,
      appointNo,
      valueOutput
    ) {
      let appointmentOutput = null;

      if (this.value.serviceOptionCosts) {
        const option = this.value.serviceOptionCosts.find(
          (_, serviceOptionCostIndex) => variantIndex === serviceOptionCostIndex
        );

        const combineOption = option
          ? option.combination_costs.find(
            (_, combinationCostIndex) => combinationCostIndex === combineOptionIndex)
          : null;

        const combineAppointment = combineOption
          ? combineOption.appointment_costs.find((combinationCost) => (
              combinationCost.appoint_no === appointNo)
            )
          : null;

        if (combineAppointment) {
          if (typeof combineAppointment[valueOutput] == Number) {
            appointmentOutput = parseFloat(combineAppointment[valueOutput])
          } else {
            appointmentOutput = combineAppointment[valueOutput]
          }
        }
      }

      return appointmentOutput
    },
    getOldOptionIdOrGenerate(variantIndex) {
      let optionId = uuid.v4();

      if (this.value.serviceOptionCosts) {
        this.value.serviceOptionCosts.map(
          (serviceOptionCost, serviceOptionCostIndex) => {
            if (serviceOptionCostIndex === variantIndex) {
              optionId = serviceOptionCost.id;
            }
          });
      }

      return optionId
    },
    handleEmptyOptionCost() {
      this.$emit("setEmptyServiceOptionCosts");
    },
    handleCheckCombineOption(value) {
      this.$emit("isCheckCombineOption", value);
    },
    handleUnitName(value) {
      if (value) {
        this.$emit("input",  {
          ...this.value,
          unitName: value.unitName,
          codeDescriptionUnit: value.codeDescriptionUnit
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.service-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }

  &.cost {
    width: 150px;
  }

  &.minimumAdvanceDuration {
    width: 80px;
  }
}

.input > textarea {
  min-height: 120px;
}

.inputChoice {
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
}

.thumbnail {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.icon-container {
  max-width: 180px;
}

.provider-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.provider-select {
  width: 100%;
}

.externalLink {
  padding-left: 30px;
}

.grid-botton-combine {
  display: grid;
  grid-template-columns: 190px 200px;
  grid-gap: 10px;
}

.revenue-dropdown {
  width: 300px;
}

.service-vat {
  font-size: 18px;
  color:  rgb(248, 103, 103);
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/services/components/ServiceEditor.vue